module.exports = __webpack_public_path__ + "static/media/0021_LES_MURS_BARDAGE_BOIS_HORIZONTAL.a07005b4.webp";